import React, { useState } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import { Formik } from 'formik';

import { ButtonSplitGroup } from '@components/Buttons';
import { DefaultSpinnerCenter } from '@components/Loader/Loader';
import {
  ProfileDataTable,
  ProfileDocumentsTable,
} from '@components/Numbers/Details/Table';
import { REASSIGNMENT_TYPE } from '@config/const';
import { Page500 } from '@containers/ErrorPages';
import { checkIsReady } from '@features/queryUtils';
import { numberApi } from '@reducers/number/number';
import { profileApi } from '@reducers/profile/profile';

export const ProfileForm = ({ did, profileID }) => {
  const [profile, setProfile] = useState(profileID);
  const profiles = profileApi.useGetForSelectQuery();

  const [trigger] = numberApi.useApplyForEndUserTransferMutation();

  const { data, isLoading, isFetching, isError } =
    profileApi.useGetProfileFormDataQuery({ id: profile, did });

  if (isLoading || isFetching) {
    return <DefaultSpinnerCenter />;
  }
  if (isError) {
    return <Page500 />;
  }

  const handleProfileSelection = (e) => {
    setProfile(e.target.value);
  };

  return (
    <Formik
      enableReinitialize
      initialValues={{ profileID: profile }}
      onSubmit={() => {}}
    >
      {({ handleSubmit, handleChange, handleBlur, values }) => (
        <Form onSubmit={handleSubmit}>
          <Row>
            <Col md={4}>
              <Form.Group
                as={Row}
                className="mb-1"
                controlId="form.ControlProfile"
              >
                <Col>
                  <Form.Select
                    name="profileID"
                    value={values.profileID}
                    onChange={(e) => {
                      handleChange(e);
                      handleProfileSelection(e);
                    }}
                    disabled={profiles.isLoading || profiles.isFetching}
                    onBlur={handleBlur}
                  >
                    <option value="">
                      {profiles.isLoading ? 'Loading...' : 'Select end user'}
                    </option>
                    {checkIsReady(profiles)
                      ? profiles.data.map((item) => (
                          <option key={item.value} value={item.value}>
                            {item.name}
                          </option>
                        ))
                      : null}
                  </Form.Select>
                </Col>
              </Form.Group>
            </Col>
            <Col md={8}>
              <ButtonSplitGroup>
                <Button
                  variant="didxl"
                  size="sm"
                  as={Link}
                  to={`/profiles/edit/${values.profileID}`}
                >
                  Edit End user
                </Button>
                <Button variant="didxl" size="sm" as={Link} to="/profiles/new">
                  Add new End user profile
                </Button>
                {data.reassign_allowed === REASSIGNMENT_TYPE.REASSIGNMENT &&
                profile !== profileID ? (
                  // Only for new profiles not current DID.Profile
                  <Button
                    variant="didxl"
                    size="sm"
                    onClick={() => {
                      trigger({ did, body: { profile } });
                    }}
                  >
                    Apply End user profile to DID
                  </Button>
                ) : null}
                {data.reassign_allowed !== REASSIGNMENT_TYPE.REASSIGNMENT ? (
                  <span>Number reassignment is not Allowed for this Plan.</span>
                ) : null}
              </ButtonSplitGroup>
            </Col>
          </Row>
          <Row className="mt-2">
            <Col md={6}>
              <ProfileDataTable data={data.fields} did={did} />
            </Col>
            <Col md={6}>
              <ProfileDocumentsTable data={data.documents} did={did} />
            </Col>
          </Row>
        </Form>
      )}
    </Formik>
  );
};
